import { render } from "./SpinLoader.vue?vue&type=template&id=4c64caed&scoped=true"
import script from "./SpinLoader.vue?vue&type=script&lang=js"
export * from "./SpinLoader.vue?vue&type=script&lang=js"

import "./SpinLoader.vue?vue&type=style&index=0&id=4c64caed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c64caed"]])

export default __exports__